import { render, staticRenderFns } from "./InterventionPlanObjetives.vue?vue&type=template&id=15860acf&scoped=true"
import script from "./InterventionPlanObjetives.vue?vue&type=script&lang=js"
export * from "./InterventionPlanObjetives.vue?vue&type=script&lang=js"
import style0 from "./InterventionPlanObjetives.vue?vue&type=style&index=0&id=15860acf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15860acf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15860acf')) {
      api.createRecord('15860acf', component.options)
    } else {
      api.reload('15860acf', component.options)
    }
    module.hot.accept("./InterventionPlanObjetives.vue?vue&type=template&id=15860acf&scoped=true", function () {
      api.rerender('15860acf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referral-management/search/components/InterventionPlanObjetives.vue"
export default component.exports